// Display a reorder columns list for grid column order (CPGridV2 version)
import CPSortableList, {
  CPSortableListItem,
} from "shared/components/shared/CPSortableList/CPSortableList";
import * as React from "react";
import { CPGridV2Column } from "../types";

interface CPReorderColumnsListProps {
  columns: CPGridV2Column[];
  onUpdate: (sortedColumns: CPGridV2Column[]) => void;
}

const CPReorderColumnsList: React.FC<CPReorderColumnsListProps> = (props) => {
  const data = props.columns
    .filter((x) => !x.pinned && !x.hide && x.columnType !== "menu")
    .map((x, i) => ({
      key: x.title ?? i,
      text: x.title,
    }));

  const handleSort = (items: CPSortableListItem[]) => {
    const updatedCols = items.reduce((prev, item) => {
      const column = props.columns.find((x) => x.title === item.key);

      if (column) {
        prev.push({ ...column });
      }

      return prev;
    }, [] as CPGridV2Column[]);

    const nonMatches = props.columns.filter(
      (x) => updatedCols.some((y) => x.title === y.title) === false,
    );

    props.onUpdate([...updatedCols, ...nonMatches]);
  };

  return <CPSortableList data={data} onSort={handleSort} />;
};

export default CPReorderColumnsList;
